export default `

<ut-academy-quiz-container
  ng-if="$ctrl.featureFlags.isOn('UTEST_ACADEMY_REDESIGN_COURSE')"
  [track-id]="$ctrl.courseTrack.id"
  [use-redesign-catalog]="$ctrl.featureFlags.isOn('UTEST_ACADEMY_REDESIGN_COURSE_CATALOG')">
</ut-academy-quiz-container>

<div class="academy" ng-if="!$ctrl.featureFlags.isOn('UTEST_ACADEMY_REDESIGN_COURSE')">
  <div class="container-fluid">
    <div class="academy-header">
      <a ui-sref="academy-home">Academy</a> /
      <span>Quiz - {{$ctrl.courseTrack.name}}</span>
    </div>
    <div class="row">
      <div class="academy-course-track col-md-8">
        <course-track-quiz
          ng-if="$ctrl.courseTrack.user_can_take_quiz"
          course-track="$ctrl.courseTrack">
        </course-track-quiz>
      </div>
      <course-track-nav user="$ctrl.user" course-track="$ctrl.courseTrack"></course-track-nav>
    </div>
  </div>
</div>
`;
